const VEG_IMAGE =
  "https://images.unsplash.com/photo-1781332146569-9c5093bc2ca5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwYW5lZXIlMjB0aWtrYSUyMG5hYW58ZW58MHx8fHwxNzkxMjYxNDM0fDA&ixlib=rb-4.1.0&q=85";
const NONVEG_IMAGE =
  "https://images.unsplash.com/photo-1727280376746-b89107a5b0df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHx0YW5kb29yaSUyMGNoaWNrZW4lMjBwbGF0dGVyfGVufDB8fHx8MTc5MTI2MTQzNHww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <header
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[85vh] flex items-center justify-center text-center px-6 py-24 overflow-hidden border-b border-[#1E313D]"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 grid grid-cols-2">
          <img
            src={VEG_IMAGE}
            alt="Vegetarian feast — paneer tikka and naan served fresh"
            data-testid="hero-veg-image"
            className="w-full h-full object-cover"
          />
          <img
            src={NONVEG_IMAGE}
            alt="Non-vegetarian feast — tandoori chicken platter served hot"
            data-testid="hero-nonveg-image"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-y-0 left-1/2 w-px bg-[#D4AF37]/40"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.18)_0,transparent_65%)]"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1319] via-[#0B1319]/70 to-[#0B1319]/40"></div>
        <span
          data-testid="hero-veg-chip"
          className="absolute bottom-5 left-5 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0B1319]/85 border border-green-500/50 text-green-400 text-[11px] font-semibold tracking-widest uppercase"
        >
          <span className="w-2 h-2 rounded-full bg-green-500"></span>
          Veg Specials
        </span>
        <span
          data-testid="hero-nonveg-chip"
          className="absolute bottom-5 right-5 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0B1319]/85 border border-red-500/50 text-red-400 text-[11px] font-semibold tracking-widest uppercase"
        >
          <span className="w-2 h-2 rounded-full bg-red-500"></span>
          Non-Veg Specials
        </span>
      </div>
      <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center">
        <div
          className="reveal mb-4 inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/40 bg-[#0B1319]/80 text-[#F7D774] text-xs tracking-widest uppercase"
          data-testid="hero-tagline"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]"></span>
          <span>Good Food • Great Taste Always</span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]"></span>
        </div>
        <h1
          className="reveal font-display text-4xl sm:text-5xl lg:text-6xl sm:whitespace-nowrap font-bold text-[#F3EAD8] leading-[1.1] mb-6"
          style={{ animationDelay: "0.15s" }}
          data-testid="hero-headline"
        >
          Every meal an occasion feast.
        </h1>
        <p
          className="reveal max-w-2xl text-base sm:text-lg text-[#A8B8C0] leading-relaxed mb-8"
          style={{ animationDelay: "0.3s" }}
          data-testid="hero-subtext"
        >
          Not occasional, but an authentic occasion feast created daily for
          Nagpur's diners. Experience rich hand-ground Savji curries, sizzling
          tandoor platters, Mughlai gravies, and fragrant dum biryanis.
        </p>
        <div
          className="reveal flex flex-col sm:flex-row items-center gap-4"
          style={{ animationDelay: "0.45s" }}
        >
          <a
            href="#menu"
            data-testid="hero-explore-menu-btn"
            className="w-full sm:w-auto px-8 py-3.5 bg-gradient-to-r from-[#D4AF37] to-[#F7D774] text-[#0B1319] font-bold text-sm tracking-wide rounded-sm shadow-lg hover:shadow-[#D4AF37]/20 transition-all"
          >
            Open the Menu Book
          </a>
          <a
            href="#contact"
            data-testid="hero-location-btn"
            className="w-full sm:w-auto px-7 py-3.5 border border-[#D4AF37]/50 text-[#F7D774] font-medium text-sm rounded-sm hover:bg-[#D4AF37]/10 transition-all"
          >
            Dine-in Hours & Location
          </a>
        </div>
      </div>
    </header>
  );
}
